import React, { Component } from "react";
import {
  Form,
  InputGroup,
  Button,
} from "react-bootstrap";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import {
  IVideoDetailProps,
  IVideoDetailState
} from "../../interfaces/video.interface";
import { IRootState } from "../../interfaces";
import { videoDetailRequest } from "../../action";
import { FrontendUrl } from "../../config";
import Loader from '../../components/Loader/Loader';
import { AppRoutes } from '../../config';
import { logger } from "../../helper/Logger";
import noImage from "../../assets/images/no-image.png";
class Video extends Component<IVideoDetailProps, IVideoDetailState> {
  constructor(props: IVideoDetailProps) {
    super(props);
    this.state = { displayvideo: "", search: "",videoId:"", takeReview: true, videosToShow: 3 };
  }
  componentDidMount = () => {
    if(window.matchMedia("(max-width: 767px)").matches) {
      this.setState({
        videosToShow : 1
      });
    } else {
      this.setState({
        videosToShow : 3
      });
    }
    //const { search } = this.state
    let data = {"allVideos":"true"};
    this.props.getVideoInfo(data);
  };

  componentDidUpdate = (prevProps: IVideoDetailProps, prevState: IVideoDetailState) => {
    const { videoDetailReducer } = this.props;
    const { videoDetailsData } = videoDetailReducer;
  };




  ChangeVideo = (item: any, index: Number) => {
    let input = document.getElementById(`Viddeo-${item.id}`);
    if (input) {
      (input as HTMLVideoElement).pause()
    }
    this.props.history.push(
      AppRoutes.MY_VIDEOS_VIEW.replace(
        ":id",
        item.id,

      )
    )

  }
  handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    this.setState({
      ...this.state,
      [name]: value,
    });
  };


  handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {


    e.preventDefault();
    const { search } = this.state;
    const data = {
      search
    }
    logger("in isvalid if...........");
    const { getVideoInfo } = this.props;
    if (getVideoInfo) {
      logger("Api calling...........");
      await getVideoInfo(data);
    }
  };

  rederVideoData = (item: any, index: any, categoryId: any) => {
    let hideVideo = "";
    if(index >= this.state.videosToShow) {
      hideVideo = "none";
    }
    let videoDivId = categoryId+"_"+index; 
    return (
      
      <div className="col-lg-4 col-md-4 col-sm-12" style={{display:hideVideo}} id={videoDivId}>
          <div
            className="video-section"
            onClick={() => {
              this.ChangeVideo(item, index); 
            }}
          >


            <div className="form-video">



              {item.thumbnailUrl ? (
                <img
                  src={`${FrontendUrl}${item.thumbnailUrl}`}
                  alt=""
                  className="video-main"
                  width="180"
                  height="180"
                />
              ) : (
                  <img src={noImage} alt="" width="180"
                    className="video-main"
                    height="180" />
                )}

            </div>
            <span className="video-title cat-video-title">
              {item && item.title && item.title.length < 30
                ? item.title
                : item.title.substr(0, 50) + "..."}
            </span>
          </div>
        </div>
    );
  }
  nextVideos = (event: any) => {
    if(event && event.target&& event.target.parentNode) {
      let infoDiv = event.target.parentNode;
      let current = parseInt(infoDiv.getAttribute("currently-show"));
      let totalVideos = parseInt(infoDiv.getAttribute("total-videos"));
      if(totalVideos > current) {
        for(let i = this.state.videosToShow-current;i < current;i++) {
          let videoId = infoDiv.getAttribute("category-id")+"_"+i;
          let videoDiv = document.getElementById(videoId);
          if(videoDiv) {
            videoDiv.style.display = "none";
          }
        }
        for(let i = current;i < current+this.state.videosToShow;i++) {
          let videoId = infoDiv.getAttribute("category-id")+"_"+i;
          let videoDiv = document.getElementById(videoId);
          if(videoDiv) {
            videoDiv.style.display = "";
          }
        }
      }
      if(totalVideos > current) {
        infoDiv.setAttribute("currently-show",current+this.state.videosToShow);
      }
    }
  }
  prevVideos = (event: any) => {
    if(event && event.target&& event.target.parentNode) {
      let infoDiv = event.target.parentNode;
      let current = parseInt(infoDiv.getAttribute("currently-show"));
      //let totalVideos = parseInt(infoDiv.getAttribute("total-videos"));
      if(current > this.state.videosToShow) {
        for(let i = current-1;i >= current-this.state.videosToShow;i--) {
          let videoId = infoDiv.getAttribute("category-id")+"_"+i;
          let videoDiv = document.getElementById(videoId);
          if(videoDiv) {
            videoDiv.style.display = "none";
          }
        }
        for(let i = current-(this.state.videosToShow+1);i >= current-(this.state.videosToShow*2);i--) {
          let videoId = infoDiv.getAttribute("category-id")+"_"+i;
          let videoDiv = document.getElementById(videoId);
          if(videoDiv) {
            videoDiv.style.display = "";
          }
        }
      }
      if(current > this.state.videosToShow) {
        infoDiv.setAttribute("currently-show",current-this.state.videosToShow);
      }
    }
  }
  renderVideos = (videoCategorieList: any) => {
    var videoCats = Object.keys(videoCategorieList);
    var data = [];
    for(var i = 0;i < videoCats.length;i++) {
      var innerData = [];
      var cat_id = "";
      var categoryName = "";
      var cat_video_length = videoCategorieList[videoCats[i]].length;
      for(var j = 0;j < cat_video_length;j++) {
        categoryName = videoCategorieList[videoCats[i]][j].cat_name;
        innerData.push(this.rederVideoData(videoCategorieList[videoCats[i]][j], j, videoCats[i]));
      }
      cat_id = videoCats[i];      
      data.push(<div currently-show={this.state.videosToShow} category-id={cat_id} total-videos={cat_video_length}><a href="javascript:void(0)" className="previous" onClick={this.prevVideos}>&#8249;</a><a href="javascript:void(0)" className="nextVideo" onClick={this.nextVideos}>&#8250;</a><h4 className="video-title cat-video-name">{categoryName}</h4></div>);
      data.push(<div className="row">{innerData}</div>)
    }
    return(data);
  }
  render() {
    const { videoDetailReducer } = this.props;
    //const { videoDetailsData } = videoDetailReducer;
    const { search } = this.state;
    return (
      <>

        <div className="main-section" id="right-container">
          <div className="col-lg-12 col-md-12">
            <div className="container" style={{paddingLeft:"0px"}}>
              <div className="title video-search remove-shadow">
                <div className="row">
                  <div className="filter-video-section">

                  <h4 className="video-title cat-video-title">&nbsp;
                                         
                            </h4>

                    <div className="search-section">
                      <Form onSubmit={this.handleSubmit}>
                        <Form.Group
                          controlId="filter"
                          className="mb-0"
                        >
                          <span className="video-search-section">
                            {" "}
                            <Button variant="outline-info" type='submit'> <i className="fa fa-search"></i></Button>

                          </span>

                          <InputGroup>
                            <input
                              type={'text'}
                              placeholder="Search"
                              aria-label="Recipient's username"
                              aria-describedby="basic-addon2"
                              name={"search"}
                              value={search}
                              className={"form-control floating-input"}
                              onChange={this.handleChange}
                            />
                          </InputGroup>
                        </Form.Group>

                      </Form>
                    </div>


                  </div>
                </div>
              </div>
            </div>

            <section className="">
              <div className="container" style={{paddingLeft:"0px"}}>
                <div className="row">
                  <div className="col-lg-12 col-md-12">
                    {videoDetailReducer && videoDetailReducer.isLoading ? (
                      <Loader />
                    ) : (
                        <>
                          <div className="filter-div">

                            <div className="box-main cat-box-main">
                            
                              
                                {videoDetailReducer && videoDetailReducer.videoDetailsData 
                                  && videoDetailReducer.videoDetailsData.categories
                                    ? 
                                    <div>{this.renderVideos(videoDetailReducer.videoDetailsData.categoriesList)}</div>
                                  : <div className="col-lg-12 col-md-12 col-sm-12"> <h6 className='text-center mandatory'>No Video Found. </h6>
                                  </div>
                              }
                            </div>

                            

                          </div>
                        </>
                      )}
                  </div>

                </div>
              </div>
            </section>



          </div>
        </div>

      </>
    );
  }
}

const mapStateToProps: any = (state: IRootState) => ({
  videoDetailReducer: state.videoDetailReducer
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    getVideoInfo: (data: any) => {
      dispatch(videoDetailRequest(data));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Video);
